<script>
import Admin from "@/components/admin/admin-main-template";
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import _ from "lodash";
import DateRangeSearch from "@/components/admin/documents/date-range-search.vue";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";

export default {
  data() {
    return {
      companyId: "",
      statusOptions: [
        { text: "All", value: "SHOW_ALL" },
        { text: "Processing", value: "PROCESSING" },
        { text: "Completed", value: "SUCCESS" },
        { text: "Error", value: "ERROR" },
      ],
      docStatusList: [
        {
          text: "Processing",
          value: "PROCESSING",
          colorClass: "processing-color",
        },
        {
          text: "Completed",
          value: "SUCCESS",
          colorClass: "success-color",
        },
        {
          text: "Error",
          value: "ERROR",
          colorClass: "error-color",
        },
      ],
      snackbar: {
        show: false,
        msg: "",
        color: "success",
      },
      showDuplicateDialog: false,
      showDetailDialog: false,
      selectedItem: null,
      regenerating: false,
      selectedItems: [],
      regeneratingMultiple: false,
      maxSelection: 10,
      showConfirmDialog: false,
      confirmType: null, // 'single' or 'multiple'
    };
  },
  name: "fileTracking",
  components: {
    DateRangeSearch,
    Admin,
  },
  created() {
    let companyId = this.$route.params.companyId;

    if (companyId) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyId });
      this.companyId = companyId;
    }
  },
  methods: {
    ...mapActions("fileTracking", [
      "subscribeToFileTracks",
      "unsubscribeFromFileTracks",
      "paginate",
      "sortTable",
      "updateSearch",
      "resetSearch",
      "setCurrentPage",
    ]),
    getDocStatus(value) {
      const docStatus = this.docStatusList.find(
        (status) => status.value === value
      );
      return docStatus;
    },
    getStatusTH(status) {
      return this.getDocStatus(status)?.text;
    },
    getColorClass(status) {
      return this.getDocStatus(status)?.colorClass;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.snackbar = {
        show: true,
        color: "success",
        msg: "คัดลอกสำเร็จ",
        icon: "mdi-check",
      };
    },
    debounceInput: _.debounce(function () {
      this.updateSearch({
        companyId: this.companyId,
        searchFileName: this.localSearchFileName,
      });
    }, 1000),
    handleStatusSearch() {
      this.updateSearch({
        companyId: this.companyId,
        searchStatus: this.localSearchStatus,
      });
    },
    handleSortTable(column) {
      this.sortTable(column);
    },
    getThaiDate(timestamp) {
      if (!timestamp) return "N/A";
      moment.locale("th");

      const date = timestamp.seconds
        ? new Date(timestamp.seconds * 1000)
        : new Date(timestamp);

      const formattedDate = moment(date).add(543, "years").format("DD MMM YY");
      return formattedDate;
    },
    getThaiDateTime(timestamp) {
      if (!timestamp) return "N/A";
      moment.locale("th");

      const date = timestamp.seconds
        ? new Date(timestamp.seconds * 1000)
        : new Date(timestamp);

      const formattedDate = moment(date)
        .add(543, "years")
        .format("DD MMM YY HH:mm");
      return formattedDate;
    },
    async fetchFileTracksByDateRange(fromDate, toDate) {
      await this.updateSearch({
        companyId: this.companyId,
        searchStartDate: fromDate,
        searchEndDate: toDate,
      });
    },
    async handleResetDateSearch() {
      await this.resetSearch({ companyId: this.companyId });
    },
    getFileName(pdfPath) {
      if (!pdfPath) return "N/A";
      const parts = pdfPath.split("/");
      return parts[parts.length - 1] || "N/A";
    },
    getGcsConsoleUrl(gsPath) {
      if (!gsPath || !gsPath.startsWith('gs://')) return null;
      // gs://sld-etax.appspot.com/Companies/xxx/PDFs/file.pdf
      // -> https://console.cloud.google.com/storage/browser/_details/sld-etax.appspot.com/Companies/xxx/PDFs/file.pdf
      const withoutPrefix = gsPath.replace('gs://', '');
      return `https://console.cloud.google.com/storage/browser/_details/${withoutPrefix}`;
    },
    openGcsConsole(gsPath) {
      const url = this.getGcsConsoleUrl(gsPath);
      if (url) {
        window.open(url, '_blank');
      }
    },
    handlePageChange(page) {
      this.setCurrentPage(page);
    },
    isDuplicatePOID(poID) {
      return this.duplicatePOIDs.some(d => d.poID === poID);
    },
    openDetailDialog(item) {
      this.selectedItem = item;
      this.showDetailDialog = true;
    },
    closeDetailDialog() {
      this.showDetailDialog = false;
      this.selectedItem = null;
    },
    showRegenerateConfirm(type) {
      this.confirmType = type;
      this.showConfirmDialog = true;
    },
    closeConfirmDialog() {
      this.showConfirmDialog = false;
      this.confirmType = null;
    },
    async confirmRegenerate() {
      this.showConfirmDialog = false;
      if (this.confirmType === 'single') {
        await this.regenerateDocument(this.selectedItem);
      } else if (this.confirmType === 'multiple') {
        await this.regenerateMultipleDocuments();
      }
      this.confirmType = null;
    },
    async regenerateDocument(item) {
      if (!item || !item.id) {
        this.snackbar = {
          show: true,
          color: "error",
          msg: "ไม่พบข้อมูลเอกสาร",
          icon: "mdi-alert-circle",
        };
        return;
      }

      this.regenerating = true;
      try {
        const docRef = fc.db
          .collection("Companies")
          .doc(this.companyId)
          .collection("PurchasePdfFiles")
          .doc(item.id);

        await docRef.update({
          refreshCount: firebase.firestore.FieldValue.increment(1),
        });

        this.snackbar = {
          show: true,
          color: "success",
          msg: "เริ่มประมวลผลเอกสารใหม่แล้ว",
          icon: "mdi-check",
        };

        this.closeDetailDialog();
      } catch (error) {
        console.error("Error regenerating document:", error);
        this.snackbar = {
          show: true,
          color: "error",
          msg: "เกิดข้อผิดพลาด: " + error.message,
          icon: "mdi-alert-circle",
        };
      } finally {
        this.regenerating = false;
      }
    },
    toggleSelectItem(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        if (this.selectedItems.length >= this.maxSelection) {
          this.snackbar = {
            show: true,
            color: "warning",
            msg: `เลือกได้สูงสุด ${this.maxSelection} รายการ`,
            icon: "mdi-alert",
          };
          return;
        }
        this.selectedItems.push(item);
      }
    },
    isItemSelected(item) {
      return this.selectedItems.some(i => i.id === item.id);
    },
    clearSelection() {
      this.selectedItems = [];
    },
    toggleSelectAll() {
      const pageItems = this.displayedItems;
      const allPageSelected = pageItems.every(item => this.isItemSelected(item));

      if (allPageSelected) {
        // Deselect all items on this page
        pageItems.forEach(item => {
          const index = this.selectedItems.findIndex(i => i.id === item.id);
          if (index > -1) {
            this.selectedItems.splice(index, 1);
          }
        });
      } else {
        // Select all items on this page (up to max)
        for (const item of pageItems) {
          if (!this.isItemSelected(item)) {
            if (this.selectedItems.length >= this.maxSelection) {
              this.snackbar = {
                show: true,
                color: "warning",
                msg: `เลือกได้สูงสุด ${this.maxSelection} รายการ`,
                icon: "mdi-alert",
              };
              break;
            }
            this.selectedItems.push(item);
          }
        }
      }
    },
    async regenerateMultipleDocuments() {
      if (this.selectedItems.length === 0) {
        this.snackbar = {
          show: true,
          color: "warning",
          msg: "กรุณาเลือกเอกสารที่ต้องการประมวลผลใหม่",
          icon: "mdi-alert",
        };
        return;
      }

      this.regeneratingMultiple = true;
      let successCount = 0;
      let errorCount = 0;

      try {
        const batch = fc.db.batch();

        for (const item of this.selectedItems) {
          if (!item.id) continue;
          const docRef = fc.db
            .collection("Companies")
            .doc(this.companyId)
            .collection("PurchasePdfFiles")
            .doc(item.id);

          batch.update(docRef, {
            refreshCount: firebase.firestore.FieldValue.increment(1),
          });
          successCount++;
        }

        await batch.commit();

        this.snackbar = {
          show: true,
          color: "success",
          msg: `เริ่มประมวลผลเอกสารใหม่ ${successCount} รายการ`,
          icon: "mdi-check",
        };

        this.clearSelection();
      } catch (error) {
        console.error("Error regenerating multiple documents:", error);
        errorCount = this.selectedItems.length - successCount;
        this.snackbar = {
          show: true,
          color: "error",
          msg: `เกิดข้อผิดพลาด: ${error.message}`,
          icon: "mdi-alert-circle",
        };
      } finally {
        this.regeneratingMultiple = false;
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.userData,
      userCompany: (state) => state.user.userCompany,
    }),
    ...mapState("fileTracking", {
      fileTracks: "fileTracks",
      displayedItems: "displayedItems",
      currentPage: "currentPage",
      itemsPerPage: "itemsPerPage",
      totalItems: "totalItems",
      loading: "loading",
      sortBy: "sortBy",
      sortDirection: "sortDirection",
    }),
    ...mapGetters("fileTracking", [
      "numPages",
      "itemsRangeText",
      "statusCounts",
    ]),
    duplicatePOIDs() {
      const poIdCounts = {};
      // Count occurrences of each POID (only for SUCCESS status with valid poID)
      this.fileTracks.forEach(item => {
        if (item.poID && item.poID !== "-" && item.status === "SUCCESS") {
          poIdCounts[item.poID] = (poIdCounts[item.poID] || 0) + 1;
        }
      });
      // Filter to only duplicates (count > 1)
      return Object.entries(poIdCounts)
        .filter(([_, count]) => count > 1)
        .map(([poID, count]) => ({ poID, count }));
    },
    hasDuplicates() {
      return this.duplicatePOIDs.length > 0;
    },
    isAllPageSelected() {
      if (this.displayedItems.length === 0) return false;
      return this.displayedItems.every(item => this.selectedItems.some(i => i.id === item.id));
    },
    isSomePageSelected() {
      if (this.displayedItems.length === 0) return false;
      return this.displayedItems.some(item => this.selectedItems.some(i => i.id === item.id));
    },
    localSearchFileName: {
      get() {
        return this.$store.state.fileTracking.searchFileName;
      },
      set(value) {
        this.$store.commit('fileTracking/SET_SEARCH_FILENAME', value);
      },
    },
    localSearchStatus: {
      get() {
        return this.$store.state.fileTracking.searchStatus;
      },
      set(value) {
        this.$store.commit('fileTracking/SET_SEARCH_STATUS', value);
      },
    },
    localSearchStartDate: {
      get() {
        return this.$store.state.fileTracking.searchStartDate;
      },
      set(value) {
        // Not used directly - handled by date range component
      },
    },
    localSearchEndDate: {
      get() {
        return this.$store.state.fileTracking.searchEndDate;
      },
      set(value) {
        // Not used directly - handled by date range component
      },
    },
  },
  watch: {
    $route: {
      handler() {
        const companyId = this.$route.params?.companyId;
        if (companyId) {
          this.companyId = companyId;
          this.resetSearch({ companyId });
        }
      },
      deep: true,
    },
  },
  mounted() {
    const companyId = this.$route.params?.companyId;
    if (companyId) {
      this.companyId = companyId;
      this.subscribeToFileTracks({ companyId });
    }
  },
  beforeDestroy() {
    this.unsubscribeFromFileTracks();
  },
};
</script>

<template>
  <Admin style="background: white">
    <v-main class="wrapper">
      <v-container fluid>
        <v-card>
          <div class="table-container">
            <div class="ma-4">
              <h2 class="tw-text-2xl tw-font-bold">File Tracking</h2>
              <p class="tw-text-gray-600 tw-mt-2">
                ติดตามสถานะการประมวลผลไฟล์ PDF
              </p>
            </div>
            
            <!-- Summary Cards -->
            <div class="summary-cards-container mx-4 mt-2 mb-3">
              <div class="tw-flex tw-gap-2">
                <div class="summary-card">
                  <v-icon class="total-icon" size="28">mdi-file-document-multiple</v-icon>
                  <div class="summary-card-content">
                    <div class="summary-card-title">Total</div>
                    <div class="summary-card-value">{{ statusCounts.total }}</div>
                  </div>
                </div>
                
                <div class="summary-card">
                  <v-icon class="processing-icon" size="28">mdi-progress-clock</v-icon>
                  <div class="summary-card-content">
                    <div class="summary-card-title">Processing</div>
                    <div class="summary-card-value">{{ statusCounts.PROCESSING }}</div>
                  </div>
                </div>
                
                <div class="summary-card">
                  <v-icon class="success-icon" size="28">mdi-check-circle</v-icon>
                  <div class="summary-card-content">
                    <div class="summary-card-title">Completed</div>
                    <div class="summary-card-value">{{ statusCounts.SUCCESS }}</div>
                  </div>
                </div>
                
                <div class="summary-card">
                  <v-icon class="error-icon" size="28">mdi-alert-circle</v-icon>
                  <div class="summary-card-content">
                    <div class="summary-card-title">Error</div>
                    <div class="summary-card-value">{{ statusCounts.ERROR }}</div>
                  </div>
                </div>

                <div
                  class="summary-card"
                  :class="{ 'duplicate-card': hasDuplicates, 'clickable-card': hasDuplicates }"
                  @click="hasDuplicates && (showDuplicateDialog = true)"
                >
                  <v-icon class="duplicate-icon" size="28">mdi-content-duplicate</v-icon>
                  <div class="summary-card-content">
                    <div class="summary-card-title">Duplicate</div>
                    <div class="summary-card-value">{{ duplicatePOIDs.length }}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <hr class="tw-mx-4 tw-pt-2 tw-opacity-10" />
            <div class="pt-8 table-toolbar">
              <v-row class="px-3 pa-0 tw-gap-4">
                <v-col cols="3" class="pa-0">
                  <v-text-field
                    class="ma-0 pa-0 tw-text-sm"
                    label="ค้นหาชื่อไฟล์"
                    dense
                    append-icon="mdi-magnify"
                    v-model="localSearchFileName"
                    @input="debounceInput"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="pa-0" cols="2">
                  <v-select
                    v-model="localSearchStatus"
                    :items="statusOptions"
                    label="สถานะ"
                    dense
                    v-on:change="handleStatusSearch"
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="pa-0" cols="4">
                  <date-range-search
                    outline
                    :initial-from-date="localSearchStartDate"
                    :initial-to-date="localSearchEndDate"
                    :on-reset="handleResetDateSearch"
                    :on-search="fetchFileTracksByDateRange"
                  />
                </v-col>
              </v-row>
            </div>

            <!-- Multi-select action bar -->
            <div
              v-if="(userCompany?.isDeveloper || user?.isEngineer) && selectedItems.length > 0"
              class="multi-select-bar mx-4 mb-2"
            >
              <div class="tw-flex tw-items-center tw-gap-3">
                <span class="tw-text-sm">
                  เลือกแล้ว {{ selectedItems.length }}/{{ maxSelection }} รายการ
                </span>
                <v-btn
                  small
                  color="warning"
                  class="tw-text-white"
                  :loading="regeneratingMultiple"
                  :disabled="regeneratingMultiple"
                  @click="showRegenerateConfirm('multiple')"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  ประมวลผลใหม่ ({{ selectedItems.length }})
                </v-btn>
                <v-btn
                  small
                  text
                  @click="clearSelection"
                  :disabled="regeneratingMultiple"
                >
                  ยกเลิก
                </v-btn>
              </div>
            </div>

            <table class="custom-table tw-text-sm">
              <thead>
                <tr>
                  <th v-if="userCompany?.isDeveloper || user?.isEngineer" class="checkbox-col">
                    <v-checkbox
                      :input-value="isAllPageSelected"
                      :indeterminate="isSomePageSelected && !isAllPageSelected"
                      @change="toggleSelectAll"
                      hide-details
                      dense
                      class="ma-0 pa-0 header-checkbox"
                    ></v-checkbox>
                  </th>
                  <th class="tw-cursor-pointer" @click="handleSortTable('timeUpdate')">
                    วันที่<br />(Date)
                    <v-icon v-if="sortBy === 'timeUpdate'">
                      {{
                        sortDirection === "asc"
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </th>
                  <th>ชื่อไฟล์<br />(File Name)</th>
                  <th>รหัสใบสั่งซื้อ<br />(PO ID)</th>
                  <th>รหัสผู้ขาย<br />(Vendor Code)</th>
                  <th>จำนวนหน้า<br />(Pages)</th>
                  <th>สถานะการสร้าง<br />(Status)</th>
                  <th>หมายเหตุ<br />(Remark)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in displayedItems"
                  :key="index"
                  :class="{
                    'duplicate-row': isDuplicatePOID(item.poID),
                    'selected-row': isItemSelected(item)
                  }"
                  @click="openDetailDialog(item)"
                >
                  <td v-if="userCompany?.isDeveloper || user?.isEngineer" class="checkbox-col" @click.stop>
                    <v-checkbox
                      :input-value="isItemSelected(item)"
                      @change="toggleSelectItem(item)"
                      hide-details
                      dense
                      class="ma-0 pa-0"
                    ></v-checkbox>
                  </td>
                  <td>{{ getThaiDateTime(item.timeUpdate) }}</td>
                  <td>{{ getFileName(item.pdfPath) }}</td>
                  <td>
                    <span v-if="isDuplicatePOID(item.poID)" class="tw-flex tw-items-center tw-gap-1">
                      <v-icon small color="warning">mdi-alert</v-icon>
                      {{ item.poID }}
                    </span>
                    <span v-else>{{ item.poID || "-" }}</span>
                  </td>
                  <td>{{ item.vendorCode || "-" }}</td>
                  <td class="tw-text-center">{{ item.pdfPageCount || "-" }}</td>
                  <td class="tw-text-xs">
                    <v-tooltip
                      top
                      max-width="350"
                      v-if="item.statusErrMsg"
                    >
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :class="`status-card ${getColorClass(item.status)}`"
                        >
                          {{ getStatusTH(item.status) }}
                        </div>
                      </template>
                      <div class="tooltip-error-msg">{{ item.statusErrMsg }}</div>
                    </v-tooltip>
                    <div
                      v-else
                      :class="`status-card ${getColorClass(item.status)}`"
                    >
                      {{ getStatusTH(item.status) }}
                    </div>
                  </td>
                  <td class="tw-max-w-xs tw-truncate" @click.stop>
                    <v-tooltip top max-width="350" v-if="item.statusErrMsg">
                      <template v-slot:activator="{ on }">
                        <span
                          v-on="on"
                          @click="copyToClipboard(item.statusErrMsg)"
                          class="hover:tw-opacity-70 tw-cursor-pointer"
                          style="user-select: none"
                        >
                          {{ item.statusErrMsg }}
                        </span>
                      </template>
                      <div class="tooltip-error-msg">
                        <v-icon color="white" small class="mr-1">mdi-content-copy</v-icon>
                        {{ item.statusErrMsg }}
                      </div>
                    </v-tooltip>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-if="fileTracks.length === 0 && !loading"
              class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
            >
              <h2>ไม่พบข้อมูล</h2>
            </div>
            <v-progress-linear
              indeterminate
              color="green"
              :active="loading"
            ></v-progress-linear>
          </div>
        </v-card>
        <v-row justify="start" class="tw-my-4">
          <div class="tw-px-4">
            {{ itemsRangeText }}
          </div>
          <v-spacer />
          <v-pagination
            :value="currentPage"
            :length="numPages"
            :total-visible="6"
            @input="handlePageChange"
          ></v-pagination>
          <v-spacer />
        </v-row>
      </v-container>
    </v-main>
    <v-snackbar
      timeout="2500"
      v-model="snackbar.show"
      :color="snackbar.color"
      top
    >
      <v-icon v-if="snackbar.icon" left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.msg }}
    </v-snackbar>

    <!-- Duplicate POID Dialog -->
    <v-dialog v-model="showDuplicateDialog" max-width="500">
      <v-card>
        <v-card-title class="tw-flex tw-items-center tw-gap-2">
          <v-icon color="warning">mdi-alert</v-icon>
          <span>พบรหัสใบสั่งซื้อซ้ำ (Duplicate PO ID)</span>
        </v-card-title>
        <v-card-text>
          <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mt-2">
            <v-chip
              v-for="dup in duplicatePOIDs"
              :key="dup.poID"
              color="warning"
              text-color="white"
              class="tw-font-medium"
            >
              {{ dup.poID }} ({{ dup.count }} รายการ)
            </v-chip>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDuplicateDialog = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detail Dialog -->
    <v-dialog v-model="showDetailDialog" max-width="650">
      <v-card v-if="selectedItem">
        <v-card-title class="tw-flex tw-items-center tw-justify-between">
          <div class="tw-flex tw-items-center tw-gap-2">
            <v-icon color="primary">mdi-file-document-outline</v-icon>
            <span>รายละเอียดไฟล์ (File Details)</span>
          </div>
          <v-chip
            small
            :color="getColorClass(selectedItem.status) === 'success-color' ? 'success' :
                    getColorClass(selectedItem.status) === 'error-color' ? 'error' : 'purple'"
            text-color="white"
          >
            {{ getStatusTH(selectedItem.status) }}
          </v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="tw-pt-4">
          <div class="detail-grid">
            <div class="detail-item">
              <div class="detail-label">
                <v-icon small class="mr-1">mdi-file-pdf-box</v-icon>
                ชื่อไฟล์ (File Name)
              </div>
              <div class="detail-value">
                <span>{{ selectedItem.fileName || getFileName(selectedItem.pdfPath) }}</span>
                <v-btn icon x-small @click.stop="copyToClipboard(selectedItem.fileName || getFileName(selectedItem.pdfPath))">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <v-icon small class="mr-1">mdi-identifier</v-icon>
                รหัสใบสั่งซื้อ (PO ID)
              </div>
              <div class="detail-value">
                <span :class="{ 'tw-text-orange-500 tw-font-semibold': isDuplicatePOID(selectedItem.poID) }">
                  {{ selectedItem.poID || '-' }}
                </span>
                <v-icon v-if="isDuplicatePOID(selectedItem.poID)" small color="warning" class="ml-1">mdi-alert</v-icon>
              </div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <v-icon small class="mr-1">mdi-store</v-icon>
                รหัสผู้ขาย (Vendor Code)
              </div>
              <div class="detail-value">{{ selectedItem.vendorCode || '-' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <v-icon small class="mr-1">mdi-folder-outline</v-icon>
                โฟลเดอร์เดือน (Month Folder)
              </div>
              <div class="detail-value">{{ selectedItem.monthFolder || '-' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <v-icon small class="mr-1">mdi-file-document-multiple-outline</v-icon>
                จำนวนหน้า (Pages)
              </div>
              <div class="detail-value">{{ selectedItem.pdfPageCount || '-' }}</div>
            </div>

            <div class="detail-item full-width">
              <div class="detail-label">
                <v-icon small class="mr-1">mdi-cloud-outline</v-icon>
                เส้นทางไฟล์ (PDF Path)
              </div>
              <div class="detail-value path-value">
                <span class="tw-break-all tw-flex-1">{{ selectedItem.pdfPath || '-' }}</span>
                <div class="tw-flex tw-gap-1 tw-ml-2">
                  <v-tooltip top v-if="selectedItem.pdfPath">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small @click.stop="copyToClipboard(selectedItem.pdfPath)">
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>คัดลอก</span>
                  </v-tooltip>
                  <v-tooltip top v-if="selectedItem.pdfPath && selectedItem.pdfPath.startsWith('gs://') && (userCompany?.isDeveloper || user?.isEngineer)">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small color="primary" @click.stop="openGcsConsole(selectedItem.pdfPath)">
                        <v-icon small>mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>เปิดใน Cloud Storage</span>
                  </v-tooltip>
                </div>
              </div>
            </div>

            <div class="detail-item full-width" v-if="selectedItem.physicalFilePath">
              <div class="detail-label">
                <v-icon small class="mr-1">mdi-folder-open-outline</v-icon>
                เส้นทางไฟล์จริง (Physical File Path)
              </div>
              <div class="detail-value path-value">
                <span class="tw-break-all">{{ selectedItem.physicalFilePath }}</span>
                <v-btn icon x-small @click.stop="copyToClipboard(selectedItem.physicalFilePath)">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>
            </div>

            <div class="detail-item full-width tw-my-2">
              <v-divider></v-divider>
            </div>

            <div class="detail-item">
              <div class="detail-inline">
                <span class="detail-label-inline"><v-icon small class="mr-1">mdi-clock-plus-outline</v-icon> วันที่สร้าง (Created)</span>
                <span class="detail-value-inline tw-text-sm mr-2">{{ getThaiDateTime(selectedItem.timeCreate) }}</span>
              </div>
            </div>

            <div class="detail-item">
              <div class="detail-inline">
                <span class="detail-label-inline"><v-icon small class="mr-1">mdi-clock-edit-outline</v-icon> วันที่อัปเดต (Updated)</span>
                <span class="detail-value-inline mr-2">{{ getThaiDateTime(selectedItem.timeUpdate) }}</span>
              </div>
            </div>

            <div class="detail-item full-width" v-if="selectedItem.statusErrMsg">
              <div class="detail-label tw-text-red-600">
                <v-icon small class="mr-1" color="error">mdi-alert-circle-outline</v-icon>
                ข้อผิดพลาด (Error Message)
              </div>
              <div class="detail-value error-msg">
                <span>{{ selectedItem.statusErrMsg }}</span>
                <v-btn icon x-small @click.stop="copyToClipboard(selectedItem.statusErrMsg)">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            v-if="userCompany?.isDeveloper || user?.isEngineer"
            text
            color="warning"
            :loading="regenerating"
            :disabled="regenerating"
            @click="showRegenerateConfirm('single')"
          >
            <v-icon left small>mdi-refresh</v-icon>
            ประมวลผลใหม่
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDetailDialog">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirm Regenerate Dialog -->
    <v-dialog v-model="showConfirmDialog" max-width="400">
      <v-card>
        <v-card-title class="tw-flex tw-items-center tw-gap-2">
          <v-icon color="warning">mdi-alert</v-icon>
          <span>ยืนยันการประมวลผลใหม่</span>
        </v-card-title>
        <v-card-text>
          <p v-if="confirmType === 'single'">
            คุณต้องการประมวลผลเอกสารนี้ใหม่หรือไม่?
          </p>
          <p v-else-if="confirmType === 'multiple'">
            คุณต้องการประมวลผลเอกสาร {{ selectedItems.length }} รายการใหม่หรือไม่?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeConfirmDialog">ยกเลิก</v-btn>
          <v-btn
            color="warning"
            class="tw-text-white"
            @click="confirmRegenerate"
            :loading="regenerating || regeneratingMultiple"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </Admin>
</template>

<style lang="scss" scoped>
* {
  --processing-color: rgb(159, 152, 255);
  --processing-bg-color: rgba(159, 152, 255, 0.2);
  --error-color: rgb(173, 15, 1);
  --error-bg-color: rgb(173, 15, 1, 0.2);
  --success-color: #0fb45f;
  --success-bg-color: rgba(15, 180, 95, 0.2);
  --total-color: #2196F3;
  --total-bg-color: rgba(33, 150, 243, 0.2);
}

/* Summary Cards */
.summary-cards-container {
  margin-bottom: 0.5rem;
}

.summary-card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  background: white;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  flex: 1;
  min-width: 120px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }
}

.summary-card-content {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.summary-card-title {
  font-size: 0.65rem;
  font-weight: 500;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.summary-card-value {
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1;
  color: #333;
}

.total-icon {
  color: #2196F3 !important;
}

.processing-icon {
  color: rgb(159, 152, 255) !important;
}

.success-icon {
  color: #0fb45f !important;
}

.error-icon {
  color: rgb(173, 15, 1) !important;
}

.duplicate-icon {
  color: #FF9800 !important;
}

.duplicate-card {
  border-color: #FF9800 !important;
  background-color: rgba(255, 152, 0, 0.1) !important;
}

.clickable-card {
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
  }
}

.error-color {
  color: var(--error-color);
  background-color: var(--error-bg-color);
  display: inline-block;
}

.success-color {
  color: var(--success-color);
  background-color: var(--success-bg-color);
  display: inline-block;
}

.processing-color {
  color: var(--processing-color);
  background-color: var(--processing-bg-color);
  display: inline-block;
}

.status-card {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  max-width: 200px;
}

.table-container {
  width: 100%;
  overflow-x: auto;

  td,
  th {
    white-space: nowrap;
  }
}

.table-toolbar {
  padding: 1rem;
}

.custom-table {
  border-collapse: collapse;
  width: 100%;
  overflow: hidden;
}

.custom-table th {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap;
  height: 60px;
  border-bottom: 1px solid rgb(182, 182, 182);
  font-weight: 500;
}

.custom-table td {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap;
}

.custom-table tbody tr {
  border-bottom: 1px solid #e6e6e6;
  padding: 0 10px;
  height: 3rem;
}

.custom-table tbody tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}

.custom-table tbody tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

.custom-table tbody tr.duplicate-row {
  background-color: rgba(255, 152, 0, 0.15);
}

.custom-table tbody tr.duplicate-row:hover {
  background-color: rgba(255, 152, 0, 0.25);
}

.custom-table tbody tr.selected-row {
  background-color: rgba(255, 152, 0, 0.2);
}

.custom-table tbody tr.selected-row:hover {
  background-color: rgba(255, 152, 0, 0.3);
}

.checkbox-col {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  text-align: center !important;
  padding: 0 5px !important;
}

.header-checkbox {
  display: flex;
  justify-content: center;
}

.multi-select-bar {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border: 1px solid #ffb74d;
  border-radius: 8px;
}

/* Detail Dialog Styles */
.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.detail-item.full-width {
  grid-column: span 2;
}

.detail-label {
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.detail-value {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.detail-inline {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.detail-label-inline {
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
}

.detail-value-inline {
  font-size: 0.85rem;
  color: #333;
  font-weight: 600;
  margin-left: 0.5rem;
}

.detail-value.path-value {
  background-color: #f5f5f5;
  padding: 0.5rem;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.8rem;
  word-break: break-all;
}

.detail-value.error-msg {
  background-color: rgba(244, 67, 54, 0.1);
  padding: 0.5rem;
  border-radius: 4px;
  color: #c62828;
  font-size: 0.85rem;
}
</style>

<style lang="scss">
/* Tooltip styling - not scoped to apply to v-tooltip content */
.tooltip-error-msg {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.4;
  min-height: 2.8em; /* Ensures at least 2 lines height */
  padding: 4px 0;
}
</style>
